<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card
                :loading="loading"
                class="mx-auto"
            >
              <v-toolbar
              >
<!--                <v-col>-->
<!--                  <v-icon>mdi-arrow-right</v-icon>-->
<!--                  <span>بازگشت</span>-->
<!--                </v-col>-->

                <v-col>


                <v-btn text color="#636E7B" @click="$router.go(-1)">
                  <v-icon>mdi-arrow-right</v-icon>
                  بازگشت

                </v-btn>
                </v-col>


                <v-toolbar-title>{{ title }}</v-toolbar-title>

                <v-spacer></v-spacer>

                <span>شناسه: {{this.persian(identifier)}} </span>
<!--                <v-card-text>-->
<!--                  شناسه:۱۲۳۱۲۴-->
<!--                </v-card-text>-->


<!--                <v-btn icon>-->
<!--                  <v-icon>mdi-magnify</v-icon>-->
<!--                </v-btn>-->
              </v-toolbar>

              <v-list three-line      v-for="(item, index) in chat">
                <template >
                  <v-subheader></v-subheader>

                  <v-divider
                      v-if="index!==0"
                      :key="index"
                      :inset=true
                  ></v-divider>

                  <v-list-item
                      color="#e0e0e0"
                      :key="item.title"
                  >

                    <v-list-item-avatar>
                      <v-img :src="item.user.image"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>

                      <v-list-item-title v-html="item.user.name"></v-list-item-title>


                      <v-list-item-subtitle  class="mt-2" v-text="$options.filters.stringDate(item.created_at)"></v-list-item-subtitle>


                      <h5 class="mt-5" style="color: #0c0f1a;line-height: normal" v-text="item.description ">{{item.description}}</h5>




                      <v-row class="mt-2" v-if="item.attach!=null">
                        <v-flex xs12 sm12 md6 lg6 xl6 >
                          <v-btn @click="getRequestFile(item.attach)">نمایش پیوست</v-btn>
                        </v-flex>
                      </v-row>


<!--                      <v-btn class="mt-1" @click="getRequestFile(item.attach)">نمایش پیوست</v-btn>-->



                    </v-list-item-content>

<!--                    <v-list-item-content>-->
<!--                      <v-list-item-subtitle>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</v-list-item-subtitle>-->
<!--                    </v-list-item-content>-->

                  </v-list-item>
                </template>
              </v-list>

              <v-divider/>

              <v-card class="m-5">
                <v-card-title class="pb-5">
                ارسال پاسخ تیکت
                </v-card-title>
                <v-card-text>
                  برای ارسال پاسخ به این تیکت، از فرم زیر استفاده کنید.
                </v-card-text>
<v-card-text class="mr-4">


              <h4>لطفا به نکات زیر توجه کنید:</h4>
                <ul>
                  <li>حداکثر تا ۱۲ ساعت پس از ارسال تیکت، پاسخ آن برای شما ارسال خواهد شد.</li>
                  <li>زمان پاسخ‌‌دهی به تیکت‌هایی که نیاز به بررسی یا پیگیری بیش‌تری دارند، کمی طولانی‌تر خواهد بود.</li>
                  <li>تمام تیکت‌های ارسالی، توسط کارشناسان واحد امور مشتریان ترمینال تبلیغات بررسی و پاسخ‌‌دهی می‌شوند، بنابراین جهت پیگیری وضعیت تیکت نیازی به برقراری تماس تلفنی نیست.</li>
                </ul>
</v-card-text>



                <v-card-text>

                  <v-row>
                    <v-textarea v-model="msg" dense outlined label="متن پیام"></v-textarea>

                  </v-row>


                  <v-row>
                    <v-flex xs12 sm12 md6 lg6 xl6 >
                      <v-file-input
                          v-model="attachSend"
                          label="پیوست فایل"
                          outlined
                      ></v-file-input>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                      <v-btn @click="sendTicketResponse" :loading="loading" color="#50858B"  class="text-white p-6 ml-30"
                      >
                        <v-icon class="ml-4">mdi-send</v-icon>
                        ارسال پاسخ
                      </v-btn>
                    </v-flex>
                  </v-row>

                </v-card-text>
              </v-card>





            </v-card>

          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import error from "@/view/pages/error/Error";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  props: ['id'],
  data() {
    return {
      loading:false,
      title: '',
      identifier:null,
      attachSend:null,
      ttext: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.',
      ckEditor: false,
      textArea: true,
      chat: [],
      attach:null,
      msg: null,
      notify_type: '',
      notify_types: [
        {name: 'sms', value: 'پیامک'},
        {name: 'email', value: 'ایمیل'},
        {name: 'notification', value: 'اطلاع رسانی'},
        {name: 'push_notification', value: 'اطلاع رسانی پنل'}
      ],
      cost: '',
      users: [],
      extras: {
        notify_at: '',
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
    }
  },
  methods: {
    sendTicketResponse() {

      let formData = new FormData();
      // formDataa.append('description', 'slmm')
      formData.append('ticket_id', this.id)
      formData.append('description', this.msg)
      if (this.attachSend != null) formData.append('attach', this.attachSend);



      this.loading = true;
      this.requestApiPost('conversation', formData,this.configurationFile()).then((response) => {
        this.loading = false;
        this.$toast.success('پیام شما با موفقیت ارسال شد.');
        this.$router.push({name: 'tickets.index'});
      }).catch(({response}) => {
        this.errors = response.data;
        console.log(response.data);
        this.loading = false;
      });
    },

    findTicket() {
      this.loading=true
      this.requestApiGet(`ticket/${this.id}`).then(({data}) => {
        this.identifier=this.id;
        this.title = data.title;
        this.chat = data.messages;
        // this.cost = data.data.cost;
        // this.extras = data.data.extras;
        // this.users = data.data.users;
        this.loading=false
      }).catch((error) => {
        this.loading=false
        console.log(error);
      });
    },

    getRequestFile(attach) {
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = this.$uploadUrl+attach;
      a.click();
    },
  },

  created() {
    this.findTicket();
    this.$store.dispatch(SET_BREADCRUMB, [{name: this.$route.meta.title}])

  }
}
</script>
<style scoped>
ul {
  list-style: none;
}
ul li::before {
  content: "\2022";
  color: red;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-right: -1em;
}
</style>